import type { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { fetchJson$ } from '@atlassian/jira-servicedesk-common/src/utils/fetch';
import type { Group, GroupsResponse } from '../../common/types';

export const getGroupsUrl = (projectId: number) =>
	`/rest/servicedesk/1/servicedesk/${projectId}/portal-groups`;

const getGroupsRest = (projectId: number): Observable<Group[]> =>
	fetchJson$(getGroupsUrl(projectId)).map(({ groups }: GroupsResponse) => groups);

export default getGroupsRest;
